"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBackgroundCheckScreeningStatusDto = instanceOfBackgroundCheckScreeningStatusDto;
exports.BackgroundCheckScreeningStatusDtoFromJSON = BackgroundCheckScreeningStatusDtoFromJSON;
exports.BackgroundCheckScreeningStatusDtoFromJSONTyped = BackgroundCheckScreeningStatusDtoFromJSONTyped;
exports.BackgroundCheckScreeningStatusDtoToJSON = BackgroundCheckScreeningStatusDtoToJSON;
exports.BackgroundCheckScreeningStatusDtoToJSONTyped = BackgroundCheckScreeningStatusDtoToJSONTyped;
const BackgroundCheckScreeningStatus_1 = require("./BackgroundCheckScreeningStatus");
/**
 * Check if a given object implements the BackgroundCheckScreeningStatusDto interface.
 */
function instanceOfBackgroundCheckScreeningStatusDto(value) {
    if (!('serviceId' in value) || value['serviceId'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('pendingStatus' in value) || value['pendingStatus'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
function BackgroundCheckScreeningStatusDtoFromJSON(json) {
    return BackgroundCheckScreeningStatusDtoFromJSONTyped(json, false);
}
function BackgroundCheckScreeningStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'serviceId': json['serviceId'],
        'name': json['name'],
        'status': (0, BackgroundCheckScreeningStatus_1.BackgroundCheckScreeningStatusFromJSON)(json['status']),
        'pendingStatus': json['pendingStatus'],
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}
function BackgroundCheckScreeningStatusDtoToJSON(json) {
    return BackgroundCheckScreeningStatusDtoToJSONTyped(json, false);
}
function BackgroundCheckScreeningStatusDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'serviceId': value['serviceId'],
        'name': value['name'],
        'status': (0, BackgroundCheckScreeningStatus_1.BackgroundCheckScreeningStatusToJSON)(value['status']),
        'pendingStatus': value['pendingStatus'],
        'updatedAt': (value['updatedAt'] == null ? null : value['updatedAt'].toISOString()),
    };
}
//# sourceMappingURL=BackgroundCheckScreeningStatusDto.js.map